import { useState, useEffect } from 'react';

/**
 * Custom hook for debouncing value changes
 * @param value - Value to debounce
 * @param delay - Delay in milliseconds
 * @returns - Debounced value
 */
export const useDebounce = <T>(value: T, delay: number): T => {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};
